import styled from '@emotion/styled';
import { List, ListProps } from '@portalterreno/react-ui-core/List';

export type StyledListProps = ListProps;
const StyledList = styled(List)<StyledListProps>({
  width: '100%',
  alignItems: 'flex-start',
  border: 'none',
  boxShadow: 'none',
  margin: 0,
  padding: 0,
  paddingTop: 4
});

export default StyledList;
